import Api from '@/services/Api'

export default {
  index (params) {
    /*
    surname, firstNames, serviceNum, service, rank, unit, unitId, 
      enlistAddressPlaceId,
      start, pageSize) {
    */

    const sendParms = { } ;
    for (var p in params) {
      const val = params[p] ;
      if ((val === '') || (val === -1)) continue ;
      sendParms[p] = val ;
    }

    const jsonParms = JSON.stringify(sendParms) ;
    console.log("In people service params = " + jsonParms) ;

    var results = Api().get('people?param=' + jsonParms) ;
    /*
    surname=' + surname + "&firstNames=" + firstNames + "&serviceNum=" + serviceNum +
    "&service=" + service + "&rank=" + rank + "&unit=" + unit + "&unitId=" + unitId +
    "&enlistAddressPlaceId=" + enlistAddressPlaceId +
    "&start=" + start + "&limit=" + pageSize) ;
    */
    console.log("In people service back from server - results=" + results) ;
    return results ;
  },
  id (pid) {
    console.log("in people id = " + pid) ;
    var results = Api().get('person?id=' + pid) ;
    console.log("Back from API GET PERSON ID") ;
    return results ; 
  },
  edit (person, updateContext) {
    var results = Api().post('personUpdate', {person: person, updateContext: updateContext}) ;
    console.log("after edit, results=" + results) ;
    return results ;
  },
  create (newPerson) {
    console.log("in create person") ;
    var results = Api().post('personCreate', newPerson) ;
    console.log("after create, results=" + results) ;
    return results ;
  },
  editorReports (reportName, surname, start, limit) {
    console.log("PeopleService editor reports reportName=" + reportName) ;
    var results = Api().get('reports/' + reportName + "?surname=" + surname + "&start=" + start + "&limit=" + limit) ;
    console.log("Back in editorReports People Service") ;
    return results ;
  }
}



// WEBPACK FOOTER //
// ./src/services/PeopleService.js